<template>
  <div>
    <v-app id="inspire">
      <header class="header" v-if="show_item === true">
        <nav class="nav">
          <div class="container">
            <div class="row">
              <img :src="logo_url" class="logo-size" alt="logo">
              <div class="d-flex align-items-center ml-auto mr-5">
                <span class="mobile-btn" :class="{'active':menu_mobile}"
                      @click.prevent="menu_mobile = !menu_mobile"></span>
              </div>
              <div v-if="menu_mobile === true" class="mobile-menu">
                <img :src="logo_url" class="logo-size" alt="logo">
              </div>
            </div>
          </div>
        </nav>
        <div class="slide">
          <div>
            <div class="box-search">
              <search-plate></search-plate>
            </div>
            <div class="box-faq">
              <v-form>
                <v-col cols="12" md="12">
                  <p class="small-text justify-text">Para sanar suas dúvidas acerca das regras do município, valores ou
                    sobre como utilizar o aplicativo, clique no botão abaixo.</p>
                  <button class="btn-blue w-100" dark @click.prevent="modal.faq = true">
                    FAQ
                  </button>
                </v-col>
              </v-form>
            </div>
          </div>
          <div class="px-4 px-md-0">
            <v-card class="box-register" :style="{'background-color':background_color}">
              <LoginDriver></LoginDriver>
            </v-card>
          </div>
        </div>
      </header>
      <section v-show="show_about_estar" id="about-estar" class="about-estar py-5">
        <div class="col-12 col-md-7">
          <about-estar @show="show_about_estar = true"></about-estar>
        </div>
      </section>
      <section v-show="show_app_store" class="app_store" :style="{'background-color':background_color}">
        <div class="col-md-7">
          <app-store @show="show_app_store = true"></app-store>
        </div>
      </section>
      <section v-show="show_buy_estar" id="buy-estar" class="buy-estar pb-5">
        <div class="col-md-7">
          <buy-estar @show="show_buy_estar = true"></buy-estar>
        </div>
      </section>
      <section id="register-estar" class="register-estar" :style="{'background-color':background_color}"
               v-if="show_item === true">
        <div class="px-4 px-md-0">
          <register-driver @scrollToLogin="scrollTop"></register-driver>
        </div>
      </section>
      <footer v-show="show_buy_estar" class="footer">
        <div class="container">
          <footer-contact @show="show_footer_contact = true"></footer-contact>
        </div>
      </footer>
    </v-app>
    <whats-app-floater/>
    <v-dialog v-model="modal.faq" width="1200px">
      <Faq @onClose="closeModal" :isPublic="true"/>
    </v-dialog>
  </div>
</template>

<script>
import SearchPlate from './components/SearchPlate.vue';
import FooterContact from './components/FooterContact.vue';
import AppStore from './components/AppStore';
import AboutEstar from './components/AboutEstar';
import BuyEstar from './components/BuyEstar';
import LoginDriver from './components/LoginDriver';
import RegisterDriver from './components/RegisterDriver';
import WhatsAppFloater from "./components/WhatsAppFloater";
import Faq from "@/views/Faq.vue";

export default {
  name: 'landingPage',
  components: {
    Faq,
    LoginDriver,
    RegisterDriver,
    AboutEstar,
    BuyEstar,
    AppStore,
    FooterContact,
    SearchPlate,
    WhatsAppFloater,
  },
  data: function () {
    return {
      show_about_estar: true,
      show_app_store: true,
      show_buy_estar: true,
      show_footer_contact: false,
      menu_mobile: false,
      show_item: false,
      modal: {
        faq: false,
      }
    }
  },
  computed: {
    name: function () {
      return process.env.VUE_APP_NAME;
    },
    background_color: function () {
      return process.env.VUE_APP_COLOR;
    },
    logo_url: function () {
      return require('@/assets/imgs/logos/' + process.env.VUE_APP_HIGH_CONTRAST_LOGO_NAME);
    },
    show_faq() {
      return process.env.VUE_APP_FAQ_LINK;
    }
  },
  methods: {
    closeModal: function () {
      this.modal.faq = false;
    },
    scrollTop: function () {
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    showItem() {
      if (this.name !== 'Estar Digital Curitiba') {
        this.show_item = true;
      }
    }
  },
  mounted() {
    this.showItem();
  }
};
</script>
<style scoped>

* {
  color: #58595B;
  font-family: Roboto-Light;
  font-size: 14px;
}

h5 {
  font-family: Roboto-Black;
  font-size: 24px;
  color: #58595B;
}

.v-card__title h2 {
  font-size: 28px !important;
  font-family: Roboto-Black;
  color: #58595B;
}

.header {
  padding: 0;
  margin: 0;
  background-size: cover;
  /*background-image: url("../../assets/imgs/teste02.png");*/
  width: 100%;
  height: 100vh;
  /*background: gray;*/
}

.header .nav {
  padding-top: 20px;
  display: flex;
  flex-wrap: wrap;
  /*background: #EEEEEE;*/
  height: 15vh;
  /*height: 150px;*/
}

.header .nav img {
  width: 157px;
}

.header .nav ul {
  list-style: none;
  display: inherit;
  flex: 1;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 0;
}

.header .nav ul li a {
  color: #58595B;
}

.header .nav ul li a {
  color: #58595B;
  text-decoration: none;
}

.header .nav ul li a:hover {
  color: #000;
}

.header .nav ul li {
  margin-left: 25px;
  font-size: 14px;
  font-family: Roboto-Bold;
  padding: 8px 15px;
  border-radius: 4px;
  border: 3px solid transparent;
}

.header .nav ul li:hover {
  cursor: pointer;
  border: 3px solid transparent;
}

.header .nav ul li.active {
  background: transparent;
  color: #e72c1f;
  border: 3px solid #e72c1f;
  font-family: Roboto-Bold;
}

.header .nav ul li.active:hover {
  background: #e72c1f;
  color: #ffffff;
}

.header .nav ul li.active a {
  color: #e72c1f;
}

.header .nav ul li.active:hover a {
  color: #ffffff;
}

.header .slide {
  height: 85vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.header .slide .box-search {
  height: 340px;
  width: 490px;
  padding: 60px;
}

.header .slide .box-faq {
  height: 250px;
  width: 490px;
  padding: 60px;
}

.header .slide .box-search h2 {
  text-transform: uppercase;
  font-family: Roboto-Black;
  color: #58595B;
  font-size: 34px;
  margin-bottom: 25px;
}

.header .slide .box-search .btn-red {
  text-transform: capitalize;
  background: #e72c1f;
  color: #ffffff;
  font-family: Roboto-Black;
  width: 114px;
  height: 43px;
  border-radius: 4px;
  padding: 8px 15px;
  border: 3px solid #e72c1f;
}

.header .slide .box-search .btn-red:hover {
  background: transparent;
  color: #e72c1f;
}

.box-app {
  display: flex;
  justify-content: center;
  align-items: center;
}

.header .slide .box-register {
  height: auto;
  padding: 30px;
  width: 400px;
  background-size: cover;
  text-align: center !important;
}

.theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
  color: red !important;
}

.v-text-field__slot input {
  color: red
}

a {
  color: #000;
  font-family: Roboto-Bold;
  font-size: 14px;
}

.about-estar, .buy-estar, .app_store {
  display: flex;
  justify-content: space-around;
}

.about-estar {
  margin-top: 70px;
}

.register-estar {
  background-size: cover;
  width: 100%;
  display: flex;
  justify-content: space-around;
  padding: 50px 0;
  margin-top: 50px;
}


.app_store {
  width: 100%;
  padding: 50px 0;
  margin: 70px 0;
  color: #ffffff;
}

.footer {
  background: #FAFAFA;
  width: 100%;
  padding: 20px 0;
}

@media only screen and (max-width: 1024px) {
  .header .slide, .register-estar {
    display: block;
  }

  .header .slide .box-search, .header .slide .box-register, .header .slide .box-faq {
    margin: 0 auto;
  }
}

@media only screen and (max-width: 500px) {
  button {
    width: 100% !important;
  }

  .nav {
    padding: 10px !important;
    margin-bottom: 40px;
    display: flex;
    justify-content: center;
  }

  .nav ul {
    display: none !important;
  }

  .header {
    height: 800px !important;
  }

  .box-search, .box-faq {
    width: 100% !important;
    padding: 0 !important;
    height: auto !important;
    margin-bottom: 40px !important;
  }

  .box-search h2, .box-faq h2 {
    font-size: 28px !important;
    text-align: center;
  }

  .confirmRegister h2 {
    font-size: 8px !important;
  }

  .mobile-btn {
    display: none;
  }
}

@media only screen and (max-width: 500px) {
  .header {
    background-image: url("../../assets/imgs/bg02-mobile.png");
  }

  .header .slide .box-register {
    background-image: url("../../assets/imgs/bg01-mobile.png");
  }

  .register-estar {
    background-image: url("../../assets/imgs/bg01-mobile.png");
  }

  .mobile-btn {
    display: block;
    color: #000;
    width: 36px;
    height: 36px;
    border-top: 5px solid;
    float: right;
    position: relative;
    cursor: pointer;
    -webkit-backface-visibility: hidden;
    z-index: 11;
  }

  .mobile-btn::after, .mobile-btn::before {
    content: '';
    display: block;
    height: 5px;
    margin-top: 6px;
    background: currentColor;
    position: relative;
    transition: transform .2s ease;
  }

  .mobile-btn.active {
    border-top-color: transparent;
  }

  .mobile-btn.active::after {
    margin-top: 0px;
    top: 2px;
    transform: rotate(45deg);
  }

  .mobile-btn.active::before {
    margin-top: 0px;
    top: 6px;
    transform: rotate(135deg);
  }

  .mobile-menu {
    padding: 25px;
    top: 0;
    left: 0;
    overflow: hidden !important;
    position: absolute;
    margin: 0;
    background-image: url("../../assets/imgs/bg02-mobile.png");
    background-size: cover;
    width: 100%;
    height: 100vh;
    z-index: 2;
  }

  .mobile-menu li {
    height: 40px;
    margin: 30px 0;
    background: transparent;
    border-radius: 4px;
    text-align: center;
    padding: 7px 0;
  }

  .mobile-menu li a {
    text-transform: uppercase;
    font-size: 24px;
    font-family: Roboto-Black;
    color: #595959;
  }
}

@media only screen and (min-width: 501px) {
  .header {
    background-image: url("../../assets/imgs/teste02.png");
  }
}

@media only screen and (max-height: 768px) {
  .header {
    height: auto;
  }

  .header .nav {
    height: auto;
  }

  .header .slide {
    height: auto;
    padding-bottom: 50px;
  }
}

.logo-size {
  max-width: 157px;
}

.btn-blue {
  text-transform: capitalize !important;
  background: #000 !important;
  color: #ffffff !important;
  font-family: Roboto-Black !important;
  width: 120px;
  height: 43px !important;
  border-radius: 4px !important;
  padding: 8px 15px !important;
  border: 3px solid #000 !important;
}

.btn-blue:hover {
  background: transparent !important;
  color: #000 !important;
}

</style>
